module.exports = __webpack_public_path__ + "img/美容水(蓝)_05.83fdbffb.jpg";